var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFire({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 11,
    viewBox: "0 0 9 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 10C6.4215 10 8 8.53165 8 6.64705C8 6.18445 7.9755 5.68855 7.7095 4.9177C7.4435 4.14685 7.39007 4.0474 7.1089 3.5713C6.98873 4.54262 6.3459 4.94762 6.18257 5.06867C6.18257 4.94267 5.79383 3.5506 5.2042 2.71743C4.6253 1.9 3.83803 1.36382 3.3765 1C3.3765 1.69075 3.17513 2.71765 2.8865 3.241C2.5981 3.76412 2.54397 3.78325 2.18347 4.1725C1.82297 4.56175 1.65777 4.68212 1.3563 5.15462C1.05483 5.62712 1 6.25645 1 6.71905C1 8.60365 2.5785 10 4.5 10Z",
    stroke: "#FF6A24",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.28dfa43e1fc33b187e9cca9b1acebef9.svg";
export { ForwardRef as ReactComponent };